// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  apiUrl: 'http://localhost:4200',
  firebase: {
    projectId: 'mes-maleman',
    appId: '1:516835868956:web:9bb95ac25bea1fe4853ad9',
    storageBucket: 'mes-maleman.appspot.com',
    locationId: 'us-central',
    apiKey: 'AIzaSyCJ9n0yS_CkqbOZ1Sx0vjU5S-MuKqRBnsc',
    authDomain: 'mes-maleman.firebaseapp.com',
    messagingSenderId: '516835868956',
    measurementId: 'G-TM18HQ18XZ',
  },
  DOT: {
    Whse: "WHSE_DEV"
  },
  algolia: {
    appID: "ZDK5W5AJZR",
    apiKey: "3e42e91cfdf4acbbf2ed596bdc50b9e4"
  }

};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
